module.exports = __webpack_public_path__ + "static/img/cover.eb54fe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/2/cover.jpg
// module id = wCon
// module chunks = 0